import { useMemo } from "react";

import { useMapScreenshotCalculatedDefaults } from "components/map/hooks";
import useMPCScreenshotCalculatedDefaults from "components/multiphase-chart/hooks/useMPCScreenshotCalculatedDefaults";
import { useSamScreenshotCalculatedDefaults } from "components/sam/hooks";
import { useChartScreenshotCalculatedDefaults } from "components/shared/charts/hooks";
import { useXDAScreenshotCalculatedDefaults } from "components/vis/hooks";

import { useScreenshotPresetContext } from "./useScreenshotPresetContext";

export function useScreenshotCalculatedDefaults() {
  // hooks
  const { selectedPreset } = useScreenshotPresetContext();
  const chartDefaults = useChartScreenshotCalculatedDefaults();
  const mapDefaults = useMapScreenshotCalculatedDefaults();
  const samDefaults = useSamScreenshotCalculatedDefaults();
  const mpcDefaults = useMPCScreenshotCalculatedDefaults();
  const XDADefaults = useXDAScreenshotCalculatedDefaults();

  return useMemo(() => {
    // Filter out null/undefined values from selectedPreset so defaults aren't overwritten
    const presetFiltered = Object.fromEntries(
      Object.entries(selectedPreset || {}).filter(
        ([, value]) => value !== null && value !== undefined
      )
    );

    return {
      ...chartDefaults,
      ...mapDefaults,
      ...samDefaults,
      ...mpcDefaults,
      ...XDADefaults,
      ...presetFiltered
    };
  }, [chartDefaults, mapDefaults, samDefaults, mpcDefaults, XDADefaults, selectedPreset]);
}
